import { createPortal } from "react-dom";
import { ReactSVG } from "react-svg";
import cross from "../assets/svgs/cross.svg";
import Button from "./form/Button";
import success from "../assets/svgs/success.svg";

const SuccessModal = ({ close, message, title = "Success!", button1, button2 }) => {
    return createPortal(
        <div className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-full w-full md:inset-0 max-h-full bg-black bg-opacity-50">
            <div className="p-4 w-full max-w-md max-h-full">
                <div className="px-7 py-6 bg-white rounded-3xl shadow" >
                    <div>
                        {/* Success Icon */}
                        <div className="flex justify-center mb-4">
                            <ReactSVG src={success} />
                        </div>

                        {/* Title */}
                        <h2 className="text-[17px] font-semibold text-center mb-2">
                            {title}
                        </h2>

                        {/* Message */}
                        <p className="text-[15px] text-center text-gray mb-6">
                            {message}
                        </p>

                        {/* OK Button */}
                        <div className="flex gap-2 justify-center">
                            <Button
                                children={button1 || "OK"}
                                intent={"primary"}
                                size={"md"}
                                roundness={"round"}
                                eventAction={close}
                                type={Button}
                                classes={"flex-1 h-10 text-[12px] font-normal"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default SuccessModal;
